import { Leaf, Flame, Droplets, BadgeCheck } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const FEATURES = [
  { icon: Leaf, title: "100% Pure Veg", desc: "No compromises, ever. A fully vegetarian kitchen." },
  { icon: Flame, title: "Stone-Ground Podi", desc: "Gunpowder roasted & ground in-house, every morning." },
  { icon: Droplets, title: "Pure Ghee", desc: "Every dosa and idli finished with real ghee." },
  { icon: BadgeCheck, title: "FSSAI Certified", desc: "Lic. No. 20826005006580 — hygiene you can trust." },
];

const About = () => (
  <section id="story" data-testid="about-section" className="relative py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-5 lg:grid-cols-12 lg:px-8">
      <div className="relative lg:col-span-5">
        <Reveal>
          <div className="relative">
            <div className="overflow-hidden rounded-[2rem] border border-white/10">
              <img
                src="https://images.unsplash.com/photo-1596040033229-a9821ebd058d?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
                alt="Hand-ground South Indian spices"
                className="h-[380px] w-full object-cover transition-transform duration-700 hover:scale-105"
              />
            </div>
            <div className="absolute -bottom-10 -right-4 w-44 overflow-hidden rounded-2xl border border-white/10 shadow-[0_20px_50px_rgba(0,0,0,0.6)] sm:-right-8 sm:w-56">
              <img
                src="https://images.unsplash.com/photo-1606914469633-bd39206ea739?crop=entropy&cs=srgb&fm=jpg&q=85&w=500"
                alt="Podi spice blend"
                className="h-36 w-full object-cover sm:h-44"
              />
            </div>
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-7 lg:pl-6">
        <Reveal>
          <Eyebrow>Our Story</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-medium leading-tight tracking-tight text-[#F5F2EB] sm:text-4xl md:text-5xl">
            Where gunpowder meets ghee,
            <span className="text-gradient-saffron italic"> and every plate tells a story.</span>
          </h2>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-zinc-400 sm:text-lg">
            "Podi" — the fiery gunpowder of the South. "Sambaram" — the cool,
            spiced buttermilk that calms it. Together they are the rhythm of a
            South Indian table, and the soul of our kitchen. At Podi Sambaram,
            we ferment our batter overnight, roast our podi on iron tavas and
            churn our sambaram fresh through the day — the way it has been done
            for generations.
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2">
          {FEATURES.map((f, i) => (
            <Reveal key={f.title} delay={0.08 * i}>
              <div
                data-testid={`about-feature-${i}`}
                className="card-surface group rounded-2xl p-5 transition-all duration-300 hover:-translate-y-1 hover:border-[#F57C00]/40"
              >
                <f.icon
                  size={22}
                  className="text-[#F57C00] transition-transform duration-300 group-hover:scale-110"
                />
                <h3 className="mt-3 font-grotesk text-base font-semibold text-[#F5F2EB]">
                  {f.title}
                </h3>
                <p className="mt-1 text-sm leading-relaxed text-zinc-400">{f.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default About;
